import { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useFirebase } from './FirebaseContextProvider';
import UserCardTemplate from './UserCardTemplate';
import PropItem from './PropItem';
import PropItemsBlock from './PropItemsBlock';
import TournamentsList from './TournamentsList';
import FieldManagerCardEdit from './FieldManagerCardEdit';
import GuidedTour from './GuidedTour';
import placeholderPerson from '../assets/images/placeholder-person.png';

const steps = [
  {
    target: '.tabs-header-item-tournaments',
    title: 'Your tournaments',
    content: 'Here are the tournaments you manage',
  },
  {
    target: '.tabs-header-item-profile',
    title: 'Your profile',
    content: 'Your profile lives here — edit your info and contact details',
  },
];

const stepsTournaments = [
  {
    target: '.tournament:first-of-type',
    title: 'Tournament',
    content:
      'This tournament is available for you to manage. Click to see the details',
  },
];

export default function FieldManagerCard({ manager }) {
  const { user, userIsAdmin, userIsFieldManager, tournaments } = useFirebase();
  const { id, name, phone, email = [] } = manager;


  const [run, setRun] = useState(false);

  const isTheUser = user.id === id;

  // Tabs are hash-driven and only the active one is mounted, so the tour steps
  // follow the open tab
  const { hash } = useLocation();
  const onTournamentsTab = hash === '#tournaments';

  useEffect(() => {
    if (user.name) setRun(true);
  }, [user.name]);

  return (
    <GuidedTour
      steps={
        userIsFieldManager && isTheUser
          ? onTournamentsTab
            ? stepsTournaments
            : steps
          : []
      }
      // Wait for the tournaments to load, otherwise the step finds no row
      run={run && (!onTournamentsTab || tournaments.length > 0)}
      tourKey={
        onTournamentsTab
          ? 'field-manager-tournaments-v1'
          : 'field-manager-card-v1'
      }
    >
      <UserCardTemplate
        header='Field Manager'
        className='field-manager-card'
        backBtn={!isTheUser}
        isTheUser={isTheUser}
        imgPath={manager.imgPath}
        imgThumbPath={manager.imgThumbPath}
        imgTitle={name}
        name={name}
        placeholder={placeholderPerson}
        details={
          <PropItemsBlock>
            <PropItem prop='Phone' value={phone} />
            <PropItem prop='E-mail' value={email} />
          </PropItemsBlock>
        }
        editForm={
          (userIsAdmin || isTheUser) && (
            <FieldManagerCardEdit manager={manager} />
          )
        }
        tabs={[
          {
            title: 'Tournaments',
            hash: '#tournaments',
            component: <TournamentsList fieldManagerId={id} />,
          },
        ]}
      />
    </GuidedTour>
  );
}
